import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import toast from './utils/Toast';
import Navbar from './utils/Navbr';
import Loader from './utils/Loader'; 
import './style/ImportLeads.css';
import { useNavigate } from 'react-router-dom';

const ImportLeads = () => {
    // --- State ---
    const [postbackTemplate, setPostbackTemplate] = useState('');
    const [file, setFile] = useState(null);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const [parsedData, setParsedData] = useState([]);
    const [logs, setLogs] = useState([]); // { id, click_id, event, status, response }
    const [isProcessing, setIsProcessing] = useState(false);
    const [progress, setProgress] = useState(0);
    const [dragActive, setDragActive] = useState(false);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- 1. Fetch Postback Template ---
    useEffect(() => {
                const adminToken = getCookie('adminToken');

        const init = async () => {
            try {
                // ✅ 1. Admin Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuthAdmin',
                    adminToken
                });

                if (!authRes.data.status) {
                    toast.error(authRes.data.message || 'Admin session expired');
                    navigate('/cbMediaAdmin7/login');
                    return;
                }

                fetchSettings();

            } catch (err) {
                toast.error('Admin auth check failed');
                navigate('/cbMediaAdmin7/login');
            } finally {
                setLoader(false);
            }
        };
        const fetchSettings = async () => {
            const adminToken = getCookie('adminToken');
            try {
                const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'fetchGlobalSettings', // Assuming postback url is in settings
                    adminToken: adminToken || 'demo_token'
                });
                
                if (response.data.status === true) {
                    // Expecting something like: https://yourdomain.com/postback?clickid={click_id}&event={event}
                    setPostbackTemplate(response.data.data.postback || '');
                }
            } catch (error) {
                console.error(error);
                // Fallback for demo
                setPostbackTemplate('https://api.cashbolt.in.net/postback?click_id={click_id}&event={event}');
            }
        };
        init();
    }, []);

    // --- 2. File Parsing Logic ---
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) processFile(selectedFile);
    };

    const processFile = (fileObj) => {
        setFile(fileObj);
        setLogs([]);
        setProgress(0);
        
        const reader = new FileReader();
        
        reader.onload = (e) => {
            const text = e.target.result;
            let extracted = [];

            if (fileObj.name.endsWith('.json')) {
                try {
                    const json = JSON.parse(text);
                    extracted = Array.isArray(json) ? json : [json];
                } catch (err) { toast.error("Invalid JSON format"); }
            } else {
                // CSV or Text (Comma or Tab separated)
                const lines = text.split(/\r\n|\n/);
                const headers = lines[0].split(/[,\t]/).map(h => h.trim().toLowerCase());
                
                // Find index of click_id and event
                const idIndex = headers.findIndex(h => h.includes('click') || h.includes('id') || h === 'cid');
                const eventIndex = headers.findIndex(h => h.includes('event') || h.includes('goal'));

                for (let i = 1; i < lines.length; i++) {
                    const row = lines[i].split(/[,\t]/);
                    if (row.length > 1) {
                        extracted.push({
                            click_id: row[idIndex] || row[0], // Fallback to first col
                            event: eventIndex > -1 ? row[eventIndex] : (row[1] || 'default') // Fallback
                        });
                    }
                }
            }
            
            setParsedData(extracted);
            toast.success(`${extracted.length} Rows Parsed Successfully`);
        };

        reader.readAsText(fileObj);
    };

    // --- 3. Execution Logic ---
    const handleImportStart = async () => {
        if (!parsedData.length) return toast.warning("No data to import");
        if (!postbackTemplate) return toast.error("No Postback URL configured in settings");

        setIsProcessing(true);
        let completed = 0;

        // Process sequentially to avoid browser hanging, or use Promise.all for speed
        // Using a loop here for clear logging visualization
        for (let i = 0; i < parsedData.length; i++) {
            const item = parsedData[i];
            const currentClickId = item.click_id || item.clickid || item.id;
            const currentEvent = item.event || 'conversion';

            // Construct URL
            let targetUrl = postbackTemplate
                .replace('{click_id}', currentClickId)
                .replace('{clickid}', currentClickId) // Handle variations
                .replace('{pubid}', 'admin_import')
                .replace('{event}', currentEvent);

            let logEntry = {
                id: i,
                click_id: currentClickId,
                event: currentEvent,
                status: 'pending',
                response: '...'
            };

            try {
                // Fire Postback
                const response = await axios.get(targetUrl);
                
                logEntry.status = 'success';
                logEntry.response = typeof response.data === 'object' ? JSON.stringify(response.data) : response.data;
            } catch (error) {
                logEntry.status = 'failed';
                logEntry.response = error.message;
            }

            // Update Logs (Prepend new logs)
            setLogs(prev => [logEntry, ...prev]);
            
            // Update Progress
            completed++;
            setProgress(Math.round((completed / parsedData.length) * 100));
            
            // Artificial delay for visual effect (optional, remove in prod)
            await new Promise(r => setTimeout(r, 100));
        }

        setIsProcessing(false);
        toast.success("Import Process Completed");
    };

    // Drag & Drop Handlers
    const handleDrag = (e) => { e.preventDefault(); e.stopPropagation(); if(e.type === "dragenter" || e.type === "dragover") setDragActive(true); else setDragActive(false); };
    const handleDrop = (e) => { e.preventDefault(); e.stopPropagation(); setDragActive(false); if (e.dataTransfer.files && e.dataTransfer.files[0]) processFile(e.dataTransfer.files[0]); };
if (loader) return <Loader />;
    return (
        <div className="il-wrapper_il">
            <Navbar role="Administrator" isAdmin={true} />
            
            <div className="bg-shape_il shape-1_il"></div>
            <div className="bg-shape_il shape-2_il"></div>

            <div className="il-content_il">
                
                <div className="il-header_il">
                    <h2>Import <span className="highlight_il">Leads</span></h2>
                    <p>Bulk upload conversions via CSV, JSON, or Text</p>
                </div>

                {/* --- File Upload Container --- */}
                <div className="upload-section_il">
                    <div 
                        className={`drop-zone_il ${dragActive ? 'active' : ''}`}
                        onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}
                    >
                        <input 
                            type="file" 
                            id="file-upload" 
                            className="file-input_il" 
                            onChange={handleFileChange}
                            accept=".csv, .json, .txt"
                        />
                        <label htmlFor="file-upload" className="upload-label_il">
                            <div className="upload-icon_il">📂</div>
                            {file ? (
                                <div className="file-info_il">
                                    <span className="file-name_il">{file.name}</span>
                                    <span className="file-meta_il">{parsedData.length} Rows Found</span>
                                </div>
                            ) : (
                                <div className="placeholder-text_il">
                                    <span>Click to Upload</span> or Drag & Drop<br/>
                                    <small>Supports CSV, JSON, TXT</small>
                                </div>
                            )}
                        </label>
                    </div>

                    <div className="action-area_il">
                        <div className="url-preview_il">
                            <label>Target Postback Template:</label>
                            <code>{postbackTemplate}</code>
                        </div>
                        
                        <button 
                            className="start-btn_il" 
                            onClick={handleImportStart}
                            disabled={isProcessing || !file}
                        >
                            {isProcessing ? `PROCESSING ${progress}%` : 'START IMPORT'}
                            <div className="wave_il"></div>
                        </button>
                    </div>
                </div>

                {/* --- Progress Bar --- */}
                {progress > 0 && (
                    <div className="progress-container_il">
                        <div className="progress-bar_il" style={{ width: `${progress}%` }}></div>
                    </div>
                )}

                {/* --- Console / Results Table --- */}
                <div className="console-card_il">
                    <div className="console-header_il">
                        <h3>Execution Log</h3>
                        <button className="clear-btn_il" onClick={() => setLogs([])}>Clear Logs</button>
                    </div>
                    
                    <div className="console-body_il">
                        <table className="console-table_il">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Click ID</th>
                                    <th>Event</th>
                                    <th>Status</th>
                                    <th>Response Payload</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.length > 0 ? (
                                    logs.map((log) => (
                                        <tr key={log.id} className={`log-row_il ${log.status}`}>
                                            <td className="muted_il">{log.id + 1}</td>
                                            <td className="mono_il">{log.click_id}</td>
                                            <td><span className="event-tag_il">{log.event}</span></td>
                                            <td>
                                                <span className={`status-dot_il ${log.status}`}></span>
                                                {log.status.toUpperCase()}
                                            </td>
                                            <td className="response-cell_il">{log.response}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="empty-log_il">Waiting for execution...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ImportLeads;